import React from "react";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { IconButton } from "@prestosports/commons-ui";
import Printer32 from "@carbon/icons-react/lib/printer/32";
import { useTeamsContext } from "../../../../../state/teams/context";

const FootballPrintOptions = ({ isLoading, handleSetPreview }) => {
	const { state: teamState } = useTeamsContext();
	const awayTeam = teamState.awayTeam();
	const homeTeam = teamState.homeTeam();
	return (
		<FormControl>
			<FormGroup>
				<FormControlLabel
					disabled={isLoading}
					control={
						<IconButton
							disabled={isLoading}
							onClick={() => handleSetPreview("boxscore")}
						>
							<Printer32 />
						</IconButton>
					}
					label="Team Stats"
				/>
				<FormControlLabel
					disabled={isLoading}
					control={
						<IconButton disabled={isLoading} onClick={() => handleSetPreview("home")}>
							<Printer32 />
						</IconButton>
					}
					label={`Individual ${homeTeam.teamName} Stats`}
				/>
				<FormControlLabel
					disabled={isLoading}
					control={
						<IconButton disabled={isLoading} onClick={() => handleSetPreview("away")}>
							<Printer32 />
						</IconButton>
					}
					label={`Individual ${awayTeam.teamName} Stats`}
				/>
				<FormControlLabel
					disabled={isLoading}
					control={
						<IconButton
							disabled={isLoading}
							onClick={() => handleSetPreview("homePlayers")}
						>
							<Printer32 />
						</IconButton>
					}
					label={`${homeTeam.teamName} Players`}
				/>
				<FormControlLabel
					disabled={isLoading}
					control={
						<IconButton
							disabled={isLoading}
							onClick={() => handleSetPreview("awayPlayers")}
						>
							<Printer32 />
						</IconButton>
					}
					label={`${awayTeam.teamName} Players`}
				/>
				<FormControlLabel
					disabled={isLoading}
					control={
						<IconButton
							disabled={isLoading}
							onClick={() => handleSetPreview("combined")}
						>
							<Printer32 />
						</IconButton>
					}
					label="Combined Report"
				/>
			</FormGroup>
		</FormControl>
	);
};

export default FootballPrintOptions;
